import { levelContentData } from "./levelContentData.js";
import Content from "./Content.jsx";
import ReaderHome from "./ReaderHome/ReaderHome.jsx";
import HtmlMyNotes from "./HtmlMyNotes/HtmlMyNotes.jsx";

export default { 
  slug: "html",
  levelContentData,
  contentType: "lecture", 
  contentComponent: Content,
  ebookComponent: ReaderHome,
  noteComponent: HtmlMyNotes,


  tabs: [
    { label: "lectures", path: "/lectures" },
    { label: "ebooks", path: "/docs" },
    { label: "notes", path: "/notes" },
  ]
  
}

